import { Box, Button, Container, Typography } from "@mui/material";
import { images } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";
import fr from "../../locales/fr.json";
import de from "../../locales/de.json";
import pt from "../../locales/pt.json";
import ru from "../../locales/ru.json";
import zh from "../../locales/zh.json";
import ja from "../../locales/ja.json";
import ko from "../../locales/ko.json";
import ar from "../../locales/ar.json";
import hi from "../../locales/hi.json";
import nl from "../../locales/nl.json";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const locales = { en, es, it, fr, de, pt, ru, zh, ja, ko, ar, hi, nl };
const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const language = location?.state?.language || "en";
  const returnUrl = location?.state?.redirect_url;
  const params = new URLSearchParams(location.search);
  const reason = location?.state?.reason ?? params.get("reason");

  // Ensure we have a valid locale object, with defensive checks
  const selectedLocale = locales[language];
  const fallbackLocale = locales.en || {};
  const t = selectedLocale || fallbackLocale;
  // Determine message based on reason
  let errorMessage = '';
  switch (reason) {
    case 'maintenance':
      errorMessage = "The service is temporarily unavailable due to maintenance. Please try again later.";
      break;
    case 'sessionCancelled':
      errorMessage = t?.error?.sessionCancelled;
      break;
    case 'unverified':
      errorMessage = t?.unverified?.message;
      break;
    default:
      errorMessage = t?.error?.message;
  }
  const buttonText = t?.error?.button || "Go Back";
  const hasTranslationError = !t?.error;

  return (
    <Box sx={{ bgcolor: '#f5f5f7', minHeight: '100vh' }}>
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      <Container>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{
            height: { xs: "40vh", md: "60vh" },
            width: { xs: "90%", md: "40%" },
            mx: "auto",
          }}
        >
          <img
            src={images.certageError}
            alt="Logo"
            style={{
              width: "min(70vw, 300px)",
              height: "auto",
              maxHeight: "140px",
            }}
          />
          <Typography textAlign="center" fontSize={16} color="primary.text">
            {errorMessage}
          </Typography>
          {hasTranslationError && (
            <Typography textAlign="center" fontSize={12} color="error" sx={{ mt: 1 }}>
              [Translation Error - Language: {language}]
            </Typography>
          )}
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          sx={{ width: { xs: "100%", md: "70%" } }}
          mx="auto"
        >
          {reason !== 'sessionCancelled' && reason !== 'maintenance'&& (
            <Button
              fullWidth={false}
              onClick={() => {
                if (returnUrl) {
                  window.location.href = returnUrl;
                } else {
                  navigate(-1);
                }
              }}
              sx={{
                backgroundColor: "#1818de",
                px: { xs: 0, sm: 5 },
                py: 1.5,
                width: "70%",
                mx: "auto",
                borderRadius: "12px",
                mb: 2,
                fontSize: { xs: 16, sm: 24 },
                fontWeight: 600,
                color: "#fff",
                "&:hover": { backgroundColor: "#1515b0" },
              }}
            // startIcon={<ArrowBackIcon />} //
            >
              {buttonText}
            </Button>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default ErrorPage;
